import { Grid } from '@material-ui/core';
import { Originator } from '@roc/feature-loans';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import {
  SubmitRushedAppraisal
} from './formComponents';

export const AppraisalDetailsForm = observer(({ submitAppraisalStore }) => {
  const { allowOriginatorSelection } = submitAppraisalStore.isClientPortal ? submitAppraisalStore.loanParticipantsStore : false;

  useEffect(() => {
    if (submitAppraisalStore.isClientPortal) {
      submitAppraisalStore.loadStore();
    }
  }, []);

  return (
    <Grid item container justifyContent="center" spacing={2}>
      <Grid item xs={12}>
        <SubmitRushedAppraisal store={submitAppraisalStore} />
      </Grid>
      {allowOriginatorSelection && (
        <Grid item xs={12}>
          <Originator store={submitAppraisalStore} label='Originator' name='originatorId' />
        </Grid>
      )}
    </Grid>
  );
});
